export const MUTATE_LISTENER_STATE = 'MUTATE_LISTENER_STATE';

export interface IListenerStore {
    listenerState: boolean;
}


const AssetsState: IListenerStore = {
    listenerState: false,
};

// getters
const getters = {
  getListenerState: ( state: IListenerStore ) => state.listenerState,
};

// mutations
const mutations = {
  [MUTATE_LISTENER_STATE](state: IListenerStore, payload: boolean) {
    // replace the whole transactions of asset
    state.listenerState = payload;
  },
};

// actions
const actions = {
};

export default {
  state: AssetsState,
  getters,
  actions,
  mutations,
};

